export function getLegacyPaymentRetryPath(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const typeForm = window.localStorage.getItem('type_form');
  const registerId = window.localStorage.getItem('register_id');
  const token = window.localStorage.getItem('token_user_latam');

  if (!typeForm || typeForm === 'single_payment' || !registerId || !token) {
    return null;
  }

  return `/formulario/${typeForm}?register=${registerId}&token=${token}`;
}
